import { thirdPartyAppEvents, thirdPartySupportService } from '../third-party';
import { BannerInterface } from '../third-party/service/navigator/interface';
import { tracklib } from '../service/tracker';
import { getUrlParam } from '../util';
import { bannerTrackingData } from './banner-config';

export const BANNER_SHOW_CLASS = 'banner--show';
export const STORAGE_KEY_BANNER_VIEWED = 'nav-banner-displayed';

export class NavBanner extends HTMLElement {


  connectedCallback(): void {
    this.querySelectorAll('[data-banner-button=cta]').forEach((btn) => {
      btn.addEventListener('click', this.onCtaClick.bind(this));
    });

    this.querySelectorAll('[data-banner-button=close]').forEach((btn) => {
      btn.addEventListener('click', this.onCloseButtonClick.bind(this));
    });

    const removeShowListener = thirdPartySupportService.on(thirdPartyAppEvents.SHOW_BANNER, () => {
      removeShowListener();
      this.show();
    });

    thirdPartySupportService.on(thirdPartyAppEvents.HIDE_BANNER, () => {
      this.hide();
    });

    const seenSid = window.sessionStorage.getItem(STORAGE_KEY_BANNER_VIEWED);
    if (seenSid === getUrlParam('sid')) {
      setTimeout(() => {
        thirdPartySupportService.emit(thirdPartyAppEvents.HIDE_BANNER);
      }, 0);
    } else if (this.classList.contains(BANNER_SHOW_CLASS)) {
      // banner is already visible
      tracklib.track(bannerTrackingData.bannerDisplayed);
    }
  }

  show(): void {
    this.classList.add(BANNER_SHOW_CLASS);
    tracklib.track(bannerTrackingData.bannerDisplayed);
  }

  hide(): void {
    this.classList.remove(BANNER_SHOW_CLASS);
  }

  onCtaClick(): void {
    BannerInterface.handleButtonClick();
    thirdPartySupportService.emit(thirdPartyAppEvents.HIDE_BANNER);
    window.sessionStorage.setItem(STORAGE_KEY_BANNER_VIEWED, getUrlParam('sid'));
    tracklib.track(bannerTrackingData.ctaButtonClicked);
  }

  onCloseButtonClick(): void {
    thirdPartySupportService.emit(thirdPartyAppEvents.HIDE_BANNER);
    window.sessionStorage.setItem(STORAGE_KEY_BANNER_VIEWED, getUrlParam('sid'));
    tracklib.track(bannerTrackingData.closeButtonClicked);
  }
}

window.customElements.define('nav-banner', NavBanner);
